import { ADD_SALARY, UPDATE_SALARY, DELETE_SALARY, GET_SALARY } from "../type";
import { InsertData, InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateSalaryAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/Salary`, data);
    dispatch({
      type: ADD_SALARY,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_SALARY,
      payload: "Error" + e,
    });
  }
};
export const GetAllSalaryAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Salary`, quary);
    dispatch({
      type: GET_SALARY,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_SALARY,
      payload: "Error" + e,
    });
  }
};
export const UpdateSalaryAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Salary`, body);
    dispatch({
      type: UPDATE_SALARY,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_SALARY,
      payload: "Error" + e,
    });
  }
};

export const DeleteSalaryAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Salary?id=${Id}`);
    dispatch({
      type: DELETE_SALARY,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_SALARY,
      payload: "Error" + e,
    });
  }
};
